import { Link, useLocation } from "react-router-dom";
import { LayoutList, Sparkles } from "lucide-react";

export default function AdminNav() {
  const location = useLocation();
  const isRaffle = location.pathname.startsWith("/admin/raffle");
  const isDash = !isRaffle;

  return (
    <div
      className="flex gap-1 border border-white/10 bg-[#12141D] p-1 rounded-sm w-full sm:w-fit mb-6 overflow-x-auto"
      data-testid="admin-nav-tabs"
    >
      <TabLink to="/admin" active={isDash} icon={<LayoutList size={14} />} testid="admin-nav-rides">
        Rolês
      </TabLink>
      <TabLink to="/admin/raffle" active={isRaffle} icon={<Sparkles size={14} />} testid="admin-nav-raffle">
        Sorteador
      </TabLink>
    </div>
  );
}

function TabLink({ to, active, icon, testid, children }) {
  return (
    <Link
      to={to}
      className={`flex items-center gap-2 px-4 py-2 rounded-sm text-xs font-bold uppercase tracking-widest transition-colors whitespace-nowrap ${
        active
          ? "bg-[#00E5FF] text-black"
          : "text-white/70 hover:text-white"
      }`}
      data-testid={testid}
    >
      {icon} {children}
    </Link>
  );
}
